import React, { useRef, useState } from 'react';
import CompGridCmptnAllow from '@components/grid/comp-grid-cmptnAllow.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {ApiSave} from '@assets/js/api/commonApi.js';

const CmptnAllowMng = (props) => {
    /****************************
     * Define required variables
    *****************************/
    const childGridRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState({ ids: [], data: [] });

    /**************************
     * Define button functions
    ***************************/
    const onApprove = () => {
        if (selectedRows.ids.length === 0) {
            alert('승인할 항목을 선택해주세요.');
            return;
        }

        const idsArray = [...selectedRows.ids];
        const approveParams = {
            userIds: idsArray
        };

        const opt = {
            msg: {
                confirm: '선택된 ' + idsArray.length + '개 항목을 승인하시겠습니까?',
                message: '정상적으로 승인되었습니다.'
            }
        };

        ApiSave('/adm/cmptnallow/approve', approveParams, opt).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows({ ids: [], data: [] });
                onGridSearch();
            }
        });
    }

    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }

    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            userNm : {
                id : 'userId',
                label : '사용자ID',
                maxLength : 100
            },
            userNm : {
                id : 'userNm',
                label : '사용자명',
                maxLength : 100
            },
            cmptnAllowYn : {
                id: 'cmptnAllowYn',
                label: '승인상태',
                type: 'selectbox',
                grpCd: 'GRP001',
            },
        }
    }
    const buttonConfig = {
        fncButtons: [
            { id: 'approve', label: '승인처리', className: 'btn-success', onClick: onApprove },
        ],
        leftButtons: [],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />

            {/* Grid */}
            <CompGridCmptnAllow ref={childGridRef} onSelectionChange={setSelectedRows}/>
        </>
    );
}

export default CmptnAllowMng;
